import {AOperation} from "../../../models/operations/AOperation";
import {OPERATIONS_ARRAY_KEY} from "./LocalStorageKeys";
import RemapService from "../../RemapService";
import {autoFormatDate, DATE_FORMAT_WITHOUT_TIME} from "../../UtilsService";
import {EOperationType} from "../../../models/utils/EOperationType";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 28/03/2022
 * @last_update 28/03/2022
 **/
class OperationLocalService {

    public getOperations(): AOperation[] {
        let operationsRemap: AOperation[] = [];
        const jsonOperations = localStorage.getItem(OPERATIONS_ARRAY_KEY);
        if(jsonOperations) {
            let tempOperations = JSON.parse(jsonOperations);
            if(tempOperations !== null && tempOperations !== undefined) {
                for (let i = 0; i < tempOperations.length; i++) {
                    let operation: AOperation | null = RemapService.remapObjectToOperation(tempOperations[i]);
                    if(operation) {
                        operationsRemap.push(operation);
                    }
                }
            }
        }
        return operationsRemap;
    }

    public getOperationsByType(type: EOperationType) {
        let operations: AOperation[] = [];
        const currentOperations = this.getOperations();
        for(let i = 0; i < currentOperations.length; i++) {
            if(currentOperations[i].type === type) {
                operations.push(currentOperations[i]);
            }
        }
        return operations;
    }

    public countOperationsByType(type: EOperationType) {
        return this.getOperationsByType(type).length;
    }

    public getOperationsBySync(isSync: boolean): AOperation[] {
        let operations: AOperation[] = [];
        const currentOperations = this.getOperations();
        for(let i = 0; i < currentOperations.length; i++) {
            if(currentOperations[i].isSynchro === isSync) {
                operations.push(currentOperations[i]);
            }
        }
        return operations;
    }

    public getTodayOperationsSync(): AOperation[] {
        let operationsSync = this.getOperationsBySync(true);
        let todayOperationsSync: AOperation[] = [];
        const todayFormatted = autoFormatDate(new Date(), DATE_FORMAT_WITHOUT_TIME);
        for(let i = 0; i < operationsSync.length; i++) {
            const operationDateFormatted = autoFormatDate(operationsSync[i].date, DATE_FORMAT_WITHOUT_TIME);
            if(todayFormatted === operationDateFormatted) {
                todayOperationsSync.push(operationsSync[i]);
            }
        }
        return todayOperationsSync;
    }

    public getOperationsByDate(date: Date): AOperation[] {
        let operations = this.getOperations();
        let operationsByDate: AOperation[] = [];
        const dateFormatted = autoFormatDate(date, DATE_FORMAT_WITHOUT_TIME);
        for(let i = 0; i < operations.length; i++) {
            const operationDateFormatted = autoFormatDate(operations[i].date, DATE_FORMAT_WITHOUT_TIME);
            if(dateFormatted === operationDateFormatted) {
                operationsByDate.push(operations[i]);
            }
        }
        return operationsByDate;
    }

    public getOperationById(id: string): AOperation | null {
        const operations = this.getOperations();
        let operation: AOperation | null = null;
        for(let i = 0; i < operations.length; i++) {
            if(operations[i].id === id) {
                operation = operations[i];
                break;
            }
        }
        return operation;
    }

    public createOperation(operation: AOperation) {
        let operations = this.getOperations();
        operations.push(operation);
        this.saveOperationsInLocalStorage(operations);
    }

    public createOperations(operations: AOperation[]) {
        let currentOperations = this.getOperations();
        this.saveOperationsInLocalStorage(currentOperations.concat(operations));
    }

    public updateOperation(operation: AOperation) {
        const operations = this.getOperations();
        for(let i = 0; i < operations.length; i++) {
            if(operations[i].id === operation.id) {
                operations[i] = operation;
                break;
            }
        }
        this.saveOperationsInLocalStorage(operations);
    }

    public updateOperations(operations: AOperation[]) {
        let currentOperations = this.getOperations();
        for(let i = 0; i < currentOperations.length; i++) {
            for(let n = 0; n < currentOperations.length; n++) {
                if(currentOperations[n].id === operations[i].id) {
                    currentOperations[n] = operations[i];
                }
            }
        }
        this.saveOperationsInLocalStorage(currentOperations);
    }

    public saveOperationsInLocalStorage(operations: AOperation[]) {
        const stringify = JSON.stringify(operations);
        localStorage.setItem(OPERATIONS_ARRAY_KEY, stringify);
    }

    public deleteOperation(operation: AOperation) {
        const operations = this.getOperations();
        for(let i = 0; i < operations.length; i++) {
            if(operations[i].id === operation.id) {
                operations.splice(i, 1);
                break;
            }
        }
        this.saveOperationsInLocalStorage(operations);
    }

    public deleteAllOperations() {
        localStorage.removeItem(OPERATIONS_ARRAY_KEY);
    }

    public cleanLocalStorage() {
        const asyncOperations = this.getOperationsBySync(false);
        const todayOperationsSync = this.getTodayOperationsSync();
        const operations = asyncOperations.concat(todayOperationsSync);
        this.saveOperationsInLocalStorage(operations);
    }

}

export default new OperationLocalService();
